import { Component, Input } from '@angular/core';
import { TimerFormats } from '../../../../../models/timer-formats.model';
import { TimerFormatsService } from '../../../../../services/timer-formats.service';
@Component({
	selector: 'app-inline-editor',
	templateUrl: './inline-editor.component.html',
	styleUrls: ['./inline-editor.component.scss'],
	providers: [TimerFormatsService]
})
export class InlineEditorComponent {
	@Input() element;
	@Input() selectedElementIndex;
	@Input() elementType;
	timerFormats: Array<TimerFormats>;

	constructor(private tfServ: TimerFormatsService) {
		this.timerFormats = this.tfServ.getTimerFormats();
	}
}
